import React from "react";
import { Link, StaticQuery } from "gatsby";
import styled from "styled-components";
import CallButtonV2 from "./CallButtonV2";
import LinkButtonV2 from "./LinkButtonV2";
import proces1 from "../../assets/img/proces1.svg";
import proces2 from "../../assets/img/proces2.svg";
import proces3 from "../../assets/img/proces3.svg";
import proces4 from "../../assets/img/proces4.svg";

const ProcesInner = styled.div`
  .wrap {
    max-width: 1280px;
    margin: 0 auto;
    background: #F4F3F0;
    border-radius: 20px;
    padding: 60px 0;
    width: calc(100% - 50px);

    @media (max-width: 600px) {
      width: calc(100% - 20px);
      padding: 40px 0;
    }

    h2 {
      font-family: NewKansas;
      font-size: 36px;
      color: #2c4668;
      text-align: center;
      line-height: 50px;
      width: calc(100% - 40px);
      margin: 0 auto;

      @media (max-width: 899px) {
        font-size: 32px;
        line-height: 40px;
      }

      @media (max-width: 430px) {
        font-size: 28px;
        line-height: 35px;
      }
    }

    .desc {
      font-family: Visuelt-Regular;
      font-size: 18px;
      color: #394B5C;
      text-align: center;
      line-height: 28px;
      max-width: 900px;
      margin: 30px auto;
      width: calc(100% - 40px);
      margin-bottom: 80px;

      @media (max-width: 1250px) {
        max-width: 700px;
      }

      @media (max-width: 430px) {
        font-size: 16px;
        line-height: 24px;
        margin-top: 25px;
      }
    }

    .blocks {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      max-width: 1150px;
      margin: 0 auto;

      @media (max-width: 1250px) {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(2, 1fr);
        grid-column-gap: 30px;
        grid-row-gap: 50px;
        max-width: 700px;
        width: calc(100% - 50px);
        margin: 0 auto;
      }

      @media (max-width: 600px) {
        display: block;
      }
      
      .block {
        text-align: center;
        background: #FFFFFF;
        box-shadow: 0 9px 20px 0 rgba(0,0,0,0.07);
        border-radius: 10px;
        width: 230px;
        padding: 20px;
        padding-top: 50px;
        position: relative;

        @media (max-width: 1250px) {
          width: calc(100% - 40px);
          height: calc(100% - 70px);
        }

        @media (max-width: 600px) {
          margin-top: 70px;
        }

        .number {
          width: 60px;
          height: 60px;
          font-family: NewKansas;
          font-size: 36px;
          color: #2c4668;
          text-align: center;
          background: #CAD9E8;
          border-radius: 100%;
          line-height: 60px;
          position: absolute;
          top: -30px;
          left: calc(50% - 30px);
        }

        img {
          margin-bottom: 15px;
        }

        h3 {
          margin-bottom: 15px;
          font-family: Visuelt-Medium;
          font-size: 20px;
          color: #2E4963;
          text-align: center;
        }

        p {
          font-family: Visuelt-Regular;
          font-size: 15px;
          color: #44596D;
          text-align: center;
          line-height: 21px;

          a {
            color: #44596D;

          }
        }
      }
    }
  }
`;


const Proces = ({
  procesDesc,
  h2,
  procesText1,
  procesText2,
  procesText3,
  procesText4,
  cutomTabs,
  baby
}) => {
  return (
    <ProcesInner>
      <div className="wrap">
        <h2>{h2 ? h2 : "Jak to u nás probíhá?"}</h2>
        <p className="desc">{procesDesc}</p>
        <div className="blocks">

          {cutomTabs ? <>
            {cutomTabs.map(o => {
              return(
                <div className="block">
                  <div className="number">{o.num}</div>
                  <img src={o.pic} alt={o.heading} />
                  <h3>{o.heading}</h3>
                  <p>{o.desc}</p>
                </div>
              );
            })}
          
          </> : <>
            <div className="block">
              <div className="number">1</div>
              <img src={proces1} alt="Vyzvedneme vašeho blízkého" />
              <h3>{baby ? "Vyzvedneme vaše miminko" : "Vyzvedneme vašeho blízkého"}</h3>
              <p>{procesText1}</p>
            </div>
            <div className="block">
              <div className="number">2</div>
              <img src={proces2} alt="Naplánujeme společně jedinečný pohřeb" />
              <h3>{baby ? "Naplánujeme společně pohřeb a způsob uchování památky" : "Naplánujeme společně jedinečný pohřeb"}</h3>
              <p>{procesText2}</p>
            </div>
            <div className="block">
              <div className="number">3</div>
              <img src={proces3} alt="Zařídíme kremaci a veškerou dokumentaci" />
              <h3>Zařídíme kremaci a veškerou dokumentaci</h3>
              <p>{procesText3}</p>
            </div>
            <div className="block">
              <div className="number">4</div>
              <img src={proces4} alt="Předáme vám urnu s popelem" />
              <h3>Předáme vám urnu s popelem</h3>
              <p>{procesText4}</p>
            </div>
          </>}
          
        </div>
      </div>
    </ProcesInner>
  );
}

export default Proces;


